import script from "./CompanyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyTable.vue?vue&type=script&setup=true&lang=js"

import "./CompanyTable.vue?vue&type=style&index=0&id=090bf5aa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090bf5aa"]])

export default __exports__